module.exports = __webpack_public_path__ + "img/xpolar.ecf5ae03.png";